import Trends from "../components/Trends/Trends";

const TrendsPage =() =>{ 
    
      
     return(
        
         <>
            <Trends/>       
         </>
     )
}

export default TrendsPage;